import { getAllSpecializationAreasReq } from "../../../../../redux/guest-slices/common.slice"
import SpecializationAreas from "../../../../../components/ui/SpecializationAreas"
import InputField1 from "../../../../../components/ui/InputField1"
import { validateNumber } from "../../../../../utils/velidations"
import FileInput from "../../../../../components/ui/FileInput"
import { Grid2 as Grid, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Fragment, useEffect, useState } from "react"


function Financial({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b39"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="specializationCertificate"
          errText="Please upload financial advisory qualifications"
          defaultValue={specialist?.profile?.specializationCertificate || []}
          label="Financial Advisory Qualifications (e.g., Certified Financial Planner, Financial Coach) *"
          placeholderText="Upload Financial Advisory Qualifications (e.g., Certified Financial Planner, Financial Coach)"
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Areas of Expertise *"
          errText="Please select areas of expertise"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="experience"
          onChangeFun={validateNumber}
          label="Professional Experience *"
          placeholder="Enter Professional Experience"
          errText="Please enter professional experience"
          defaultValue={specialist?.profile?.experience || ""}
        />
      </Grid>

      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="additionalCertificates"
          label="Section for Credentials"
          placeholderText="Upload Additional Certificates"
          defaultValue={specialist?.profile?.additionalCertificates || []}
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >Join Innerpal as a Financial Wellness Advisor. Your guidance in financial planning and wellness can make a significant difference in our members' lives. Share your qualifications and areas of specialty
      </Typography>
    </Fragment>
  )
}

export default Financial